import { getAlpha3Codes, getName } from "i18n-iso-countries";
import React from "react";
import { useIntl } from "react-intl";

import { Select } from "src/common/components/Select";

const countryCodes = Object.keys(getAlpha3Codes());

type CountrySelectProps = Omit<React.ComponentProps<typeof Select>, "options">;

export const CountrySelect: React.FunctionComponent<
	CountrySelectProps
> = props => {
	const { locale } = useIntl();
	const options = React.useMemo(
		() =>
			countryCodes.map(value => ({
				value,
				label: getName(value, locale) ?? ""
			})),
		[locale]
	);
	return <Select {...props} options={options} />;
};
